import React from 'react';

const Card1 = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 338 260"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      d="M213.959 23.0381L214.241 23.2824H214.614H228.795H303.64L336.512 45.9873V238.077L303.665 258.604H1.01669V22.9181L46.5622 1.57394H189.189L213.959 23.0381Z"
      fill="url(#paint0_linear_83_621)"
      fillOpacity="0.7"
      stroke="url(#paint1_linear_83_621)"
      strokeWidth="2"
    />
    <clipPath
      id="card1-clippy"
      clipPathUnits="objectBoundingBox"
      transform="scale(0.0029585798816568,0.0038461538461538)"
      preserveAspectRatio="none"
    >
      <path
        d="M213.959 23.0381L214.241 23.2824H214.614H228.795H303.64L336.512 45.9873V238.077L303.665 258.604H1.01669V22.9181L46.5622 1.57394H189.189L213.959 23.0381Z"
        strokeWidth="2"
      />
    </clipPath>
    <defs>
      <linearGradient
        id="paint0_linear_83_621"
        x1="168.764"
        y1="259.604"
        x2="168.764"
        y2="0.573944"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.458807" stopColor="#050809" stopOpacity="0.45" />
        <stop offset="1" stopColor="#292023" stopOpacity="0.45" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_83_621"
        x1="347.911"
        y1="290.143"
        x2="105.641"
        y2="-54.1853"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E728E8"  />
        <stop offset="1" stopColor="#0228E8"  />
      </linearGradient>
    </defs>
  </svg>
);

export default Card1;
